import { useEffect, useState } from 'react';
import axiosInstance from '../axios/axiosInstance';
import apiEndpoints from '../axios/api';

/**
 * A community's RBAC roles, for an access-role picker.
 * Local (not Redux) so several pickers on screen stay independent.
 * Each role is `{ role_id, role_name, role_code }`.
 */
export const useSocietyRoles = (societyId) => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let alive = true;
        if (!societyId) { setRoles([]); return undefined; }
        setLoading(true);
        const url = apiEndpoints.GET_SOCIETY_ROLES_API.replace(':societyId', societyId);
        axiosInstance.get(url)
            .then((res) => { if (alive) setRoles(Array.isArray(res?.data) ? res.data : []); })
            .catch(() => { if (alive) setRoles([]); })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [societyId]);

    return { roles, loading };
};

export const roleToOption = (r) => ({ value: r.role_id, label: r.role_name });
